"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXTS = void 0;
exports.TEXTS = {
    stepOne: {
        title: '',
        subTitle: '',
        fields: {
            personName: {
                label: '',
            },
            story: {
                label: '',
            },
            photo: {
                label: '',
                photoRestriction: '',
            },
            name: {
                label: '',
            },
            email: {
                label: '',
            },
            confirmation: {
                label: '',
            },
        },
    },
    final: {
        title: '',
        subTitle: '',
    },
    sendBtn: '',
    validation: {
        stepOne: {
            person: {
                required: '',
            },
            senderName: {
                required: '',
                invalidValue: '',
            },
            email: {
                required: '',
                invalidValue: '',
            },
            confirmation: {
                required: '',
            },
            story: {
                required: '',
            },
        },
    },
    photoUploader: {
        uploadText: '',
        uploadingText: '',
        errorText: '',
        tryAgainText: '',
    },
    noOptionsText: '',
};
//# sourceMappingURL=client-form.js.map